import dayjs from 'dayjs';
import { P } from '../../theme/tokens';

export const STAGES = [
  { key: 'sourced', label: 'New Lead', color: P.subtle },
  { key: 'contacted', label: 'Contacted', color: P.info },
  { key: 'qualified', label: 'Qualified', color: P.purple },
  { key: 'proposal', label: 'Proposal', color: P.warning },
  { key: 'signed', label: 'Won', color: P.success },
  { key: 'lost', label: 'Lost', color: P.danger }
];

export const isClosedStage = (key) => key === 'signed' || key === 'lost';

export const stageOf = (key) => STAGES.find((s) => s.key === key) || STAGES[0];

export const nextStage = (key) => (isClosedStage(key) ? null : STAGES[STAGES.findIndex((s) => s.key === key) + 1] || null);

export const scoreColor = (score) => (score >= 85 ? P.success : score >= 70 ? P.info : P.warning);

export const FILE_TYPES = ['Agreement Signed', 'Pictures', 'Insurance', 'Tax Form', 'Other'];

export const FILE_TONES = { 'Agreement Signed': 'success', 'Tax Form': 'info' };

export const STATUS = {
  active: { label: 'Active', color: P.success },
  ended: { label: 'Ended', color: P.subtle }
};

export const statusOf = (o) => STATUS[o?.status] || STATUS.active;

export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

export const monthLabel = (d) => (d ? dayjs(d).format('MMM YYYY') : '');

export const monthValue = (d) => (d ? dayjs(d).format('YYYY-MM') : '');

export const termOf = (o) => (o.endedAt ? `${monthLabel(o.startedAt) || '—'} → ${monthLabel(o.endedAt)}` : `since ${monthLabel(o.startedAt) || '—'}`);

export const lastContactLabel = (d) => (d ? dayjs(d).format('MMM D, h:mm A') : '—');

export const openRequestsLabel = ({ count = 0, label = '' } = {}) => (count ? [count, label].filter(Boolean).join(' — ') : '—');
